<button
  type="button"
  (click)="onCardClick()"
  [attr.data-testid]="'product-card-' + product().id"
  [attr.data-product-name]="product().name"
  class="relative w-full h-full aspect-square rounded-xl lg:rounded-2xl bg-white/[0.03] border-2 p-3 lg:p-4 flex flex-col items-center justify-center text-center hover:bg-white/[0.08] transition-colors cursor-pointer touch-manipulation"
  [class.opacity-40]="!isActive()"
  [class.pointer-events-none]="!isActive()"
  [ngClass]="categoryColor() ? categoryColor()!.border : 'border-white/10'">
  @if (showFavoriteButton()) {
    <span
      role="button"
      tabindex="0"
      (click)="onToggleFavorite($event)"
      (keydown.enter)="onToggleFavorite($event)"
      (keydown.space)="onToggleFavorite($event)"
      [attr.aria-label]="
        isFavorite() ? ('pos.catalog.remove_favorite' | translate) : ('pos.catalog.add_favorite' | translate)
      "
      [attr.aria-pressed]="isFavorite()"
      [attr.data-testid]="'favorite-button-' + product().id"
      class="absolute top-1.5 left-1.5 z-10 cursor-pointer select-none transition-all duration-200 active:scale-90"
      [ngClass]="{
        'text-yellow-400': isFavorite(),
        'drop-shadow-[0_0_4px_rgba(250,204,21,0.8)]': isFavorite(),
        'text-white/30': !isFavorite(),
      }">
      <span class="text-sm lg:text-base">★</span>
    </span>
  }

  <span class="text-base lg:text-lg font-bold text-white leading-tight mb-2">
    {{ product().name }}
  </span>

  <div class="flex flex-col items-center gap-0.5">
    <span
      class="text-sm lg:text-base font-bold"
      [ngClass]="categoryColor() ? categoryColor()!.text : 'text-neon'">
      {{ priceFormatted() | number: '1.2-2' }} €
    </span>
    @if (canPayWithPoints()) {
      <span class="text-xs lg:text-sm text-white/60"> {{ pointsCost() }} b. </span>
    }
  </div>

  @if (isLowStock()) {
    <span
      class="absolute top-1.5 right-1.5 w-2.5 h-2.5 rounded-full bg-red-500 shadow-[0_0_6px_rgba(239,68,68,0.6)]"
      aria-label="Low stock"></span>
  }

  @if (isComposite()) {
    <span
      data-testid="drink-badge"
      class="absolute bottom-1.5 right-1.5 flex items-center justify-center text-purple-400"
      aria-label="Drink">
      <span class="material-symbols-outlined text-sm lg:text-base">local_bar</span>
    </span>
  }

  @if (quantity() > 0) {
    <span
      class="absolute -top-1.5 -right-1.5 z-10 min-w-6 h-6 lg:min-w-7 lg:h-7 rounded-full bg-neon text-night text-sm lg:text-base font-bold flex items-center justify-center px-1.5 animate-bounce-once">
      {{ quantity() }}
    </span>
  }
</button>
